module.exports = __webpack_public_path__ + "media/customizations/wildblue/back-93bf856e2ade759a238200b0ca92cb00.jpg";